<template>
    <div class="section pt-1">
        <div class="wallet-card">
            <div class="balance">
                <div class="left">
                    <span class="title mal-text">കരട് ലിസ്റ്റ്</span>
                    <h1 class="total text-primary mal-text">{{ unit.name_mal }}</h1>
                </div>
                <div class="right d-flex gap-1" v-if="permissions.update">
                    <a href="javascript:void(0);" class="button"
                        :style="visitMode ? 'background:#1DCC70;color:#fff;' : ''"
                        @click="toggleVisitMode">
                        <ion-icon name="checkmark-done-outline"></ion-icon>
                    </a>
                    <a href="javascript:void(0);" class="button" @click="openAddModal">
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- Add/Edit Pledge Modal -->
    <div class="modal fade action-sheet" id="karadModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Add New' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                <select class="form-control custom-select" v-model="isMember">
                                    <option value="">---Select---</option>
                                    <option value="Y">അതെ</option>
                                    <option value="N">അല്ല</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group basic typehead-div" v-if="isMember == 'Y' && !isEdit">
                            <div class="input-wrapper">
                                <label class="label">Member</label>
                                <v-select label="text" :filterable="true" v-model="member" :options="member_list"
                                    @search="getTextList">
                                    <template #no-options>type to search...</template>
                                    <template #option="option">
                                        <div class="d-center">{{ option.text }}</div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="input-info" v-if="member">Mobile: {{ member.country_code }} {{ member.mobile }}</div>
                        </div>
                        <div class="form-group basic" v-if="isMember == 'N' || isEdit">
                            <div class="input-wrapper">
                                <label class="label">Name</label>
                                <input type="text" class="form-control" v-model="name" placeholder="Name" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group basic" v-if="isMember == 'N' || isEdit">
                            <div class="input-wrapper">
                                <label class="label">Mobile Number</label>
                                <input type="text" class="form-control" v-model="mobile" placeholder="Mobile Number"
                                    autocomplete="off" @input="duplicateMsg = ''; duplicateDetails = null"
                                    @blur="checkMobileDuplicate" />
                                <div v-if="duplicateMsg" class="error-feedback mt-1" style="font-size:13px;">
                                    <div>{{ duplicateMsg }}</div>
                                    <div v-if="duplicateDetails && duplicateDetails.duplicate">
                                        <div>{{ duplicateDetails.name }} — {{ duplicateDetails.district_name }}, {{ duplicateDetails.zone_name }}, {{ duplicateDetails.unit_name }} ({{ duplicateDetails.list_type }})</div>
                                        <a v-if="duplicateDetails.mobile" :href="'tel:' + duplicateDetails.mobile"
                                            style="color:red;text-decoration:underline;font-weight:600;">
                                            {{ duplicateDetails.mobile }}
                                        </a>
                                        <div v-if="duplicateDetails.added_by_name" style="margin-top:4px;color:#555;font-size:12px;">
                                            Added by: <b>{{ duplicateDetails.added_by_name }}</b>
                                            <span v-if="duplicateDetails.added_by_mobile"> —
                                                <a :href="'tel:' + duplicateDetails.added_by_mobile"
                                                    style="color:#555;text-decoration:underline;">
                                                    {{ duplicateDetails.added_by_mobile }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text">പ്രതീക്ഷിക്കുന്ന സംഭാവന (തുക)</label>
                                <input type="number" class="form-control" v-model="suggested_amount" placeholder="തുക" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">Notes</label>
                                <textarea class="form-control" v-model="notes" placeholder="Notes (optional)" rows="2" autocomplete="off"></textarea>
                            </div>
                        </div>

                        <!-- Promote fields shown only on edit -->
                        <template v-if="isEdit">
                            <hr />
                            <p class="mal-text text-muted" style="font-size:13px;">തുക ലഭിച്ചാൽ ഇവിടെ ഫിൽ ചെയ്ത് Submit ചെയ്യുക:</p>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text">ഈ വ്യക്തി നൽകിയ സംഭാവന</label>
                                    <input type="number" class="form-control" v-model="collected_amount" placeholder="Amount Received" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label">Receipt Number</label>
                                    <select class="form-control custom-select" v-model="receipt_no">
                                        <option value="">---Select---</option>
                                        <option v-for="n in availableReceiptNumbers" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>

                        <div class="form-group" v-if="message">
                            <div class="error-feedback">{{ message }}</div>
                        </div>
                        <div class="form-group basic">
                            <button v-if="isEdit && collected_amount && receipt_no" type="button" class="btn btn-success btn-block btn-lg mb-1"
                                :disabled="loading" @click="promotePledge">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span class="mal-text">Main List-ലേക്ക് Move ചെയ്യുക</span>
                            </button>
                            <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="loading" @click="savePledge">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Office Payment Modal (QR / bank) -->
    <div class="modal fade action-sheet" id="officeModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">ഓഫീസ് പേയ്മെന്റ് — {{ officePledge ? officePledge.name : '' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="office-note">
                            പരിശോധനയ്ക്കായി ചേർക്കുന്നു · ഓഫീസ് വെരിഫൈ ചെയ്താൽ മാത്രമേ രസീത് (T) ജനറേറ്റ് ആകൂ.
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label"><span>Amount (₹)</span></label>
                                <input type="number" class="form-control" v-model="officeAmount" placeholder="Amount" />
                            </div>
                        </div>
                        <div class="office-panel">
                            <div class="office-panel-title">
                                <ion-icon name="receipt-outline"></ion-icon> പേയ്മെന്റ് തെളിവ്
                            </div>
                            <label class="upload-box" :class="{ filled: officeSlipName }">
                                <input type="file" accept="image/*,application/pdf" @change="onOfficeSlipChange" hidden />
                                <ion-icon :name="officeSlipName ? 'checkmark-circle' : 'cloud-upload-outline'" class="upload-icon"></ion-icon>
                                <span v-if="!officeSlipName" class="upload-text">
                                    സ്Online Transaction ചെയ്ത Screenshot ആണ് ഇവിടെ upload ചെയ്യേണ്ടത്.
                                    <small>image അല്ലെങ്കിൽ PDF</small>
                                </span>
                                <span v-else class="upload-text filled-text">
                                    {{ officeSlipName }}
                                    <small>മാറ്റാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക</small>
                                </span>
                            </label>
                            <div class="office-or"><span>അല്ലെങ്കിൽ</span></div>
                            <div class="input-wrapper">
                                <label class="label"><span>ട്രാൻസാക്ഷൻ ഐഡി <em>(optional)</em></span></label>
                                <input type="text" class="form-control" v-model="officeTxn" placeholder="Transaction / UTR ID" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="officeSaving" @click="submitOfficePayment">
                                <span v-show="officeSaving" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-2">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && pledges.total <= 0">
            ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല
        </h4>
    </div>

    <ul class="listview image-listview text inset mt-2" v-if="pledges.data && pledges.data.length">
        <li v-for="(pledge, index) in pledges.data" :key="pledge.id">
            <div class="item">
                <div class="in">
                    <!-- Visited checkbox (visit mode only) -->
                    <input v-if="visitMode" type="checkbox"
                        :checked="!!pledge.visited"
                        :disabled="!!visitingSaving[pledge.id]"
                        @change="markVisited(pledge, $event.target.checked)"
                        style="width:22px;height:22px;cursor:pointer;flex-shrink:0;margin-right:10px;accent-color:#1DCC70;" />
                    <div style="flex:1;">
                        <b>{{ (pledges.from || ((currentPage - 1) * (pledges.per_page || 0) + 1)) + index }}. {{ pledge.name }}</b>
                        <footer>{{ pledge.mobile ? pledge.mobile : '' }}
                            <template v-if="pledge.status === 'collected' && pledge.collected_amount && Number(pledge.collected_amount) !== Number(pledge.suggested_amount)">
                                | <span class="text-danger">₹{{ pledge.suggested_amount }}</span> | <span class="text-success fw-bold">₹{{ pledge.collected_amount }}</span>
                            </template>
                            <template v-else>
                                | ₹{{ pledge.suggested_amount }}
                            </template>
                        </footer>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <span v-if="visitMode && pledge.visited" class="badge bg-success mal-text" style="font-size:10px;">Visited</span>
                        <template v-if="!visitMode">
                            <span v-if="pledge.status === 'collected'" class="badge bg-success mal-text">Collected</span>
                            <span v-else class="badge bg-warning text-dark mal-text">Pending</span>
                            <div class="card-button" v-if="permissions.update">
                                <button type="button" class="btn btn-link btn-icon"
                                    data-bs-toggle="modal" :data-bs-target="'#karadAction' + pledge.id">
                                    <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!-- Action Sheet per item -->
            <div class="modal fade action-sheet" :id="'karadAction' + pledge.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ pledge.name }}</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li v-if="pledge.mobile">
                                    <a :href="'tel:' + pledge.mobile" class="btn btn-list" data-bs-dismiss="modal">
                                        <span><ion-icon name="call-outline" style="color:#1DCC70;"></ion-icon> Call</span>
                                    </a>
                                </li>
                                <li v-if="pledge.mobile">
                                    <a href="javascript:void(0);" class="btn btn-list" data-bs-dismiss="modal"
                                        @click="openWhatsApp(pledge)">
                                        <span><ion-icon name="logo-whatsapp" style="color:#25D366;"></ion-icon> WhatsApp</span>
                                    </a>
                                </li>
                                <!-- Office (QR/bank) payment for this draft person → pending, office verifies in portal -->
                                <li v-if="permissions.update && pledge.status !== 'collected' && !pledge.fund_collection_id">
                                    <a href="javascript:void(0);" class="btn btn-list text-success" data-bs-dismiss="modal"
                                        @click="openOfficePayment(pledge)">
                                        <span><ion-icon name="qr-code-outline"></ion-icon> ഓഫീസ് പേയ്മെന്റ് (QR / ബാങ്ക്)</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" class="btn btn-list" data-bs-dismiss="modal"
                                        @click="editPledge(pledge)">
                                        <span><ion-icon name="pencil-outline"></ion-icon> Edit</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" class="btn btn-list text-danger" data-bs-dismiss="modal"
                                        @click="confirmDelete(pledge)">
                                        <span><ion-icon name="trash-outline"></ion-icon> Remove</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>

    <vue-awesome-paginate v-if="pledges.last_page > 1" :total-items="pledges.total" :items-per-page="pledges.per_page"
        :max-pages-shown="3" v-model="currentPage" @click="getPledges" />

    <AlertModel ref="alert_model" :type="alert_type" :message="alert_message" />
    <DialogModel ref="dialog_model" :message="dialog_message" :action_method="dialog_action"
        :action_method_params="dialog_action_params" />
</template>

<script>
/* global bootstrap */
import vSelect from 'vue-select';
import AlertModel from './../layouts/AlertModel.vue';
import DialogModel from './../layouts/DialogModel.vue';
import UserService from '../../services/user.service';

export default {
    name: 'KaradList',
    components: { vSelect, AlertModel, DialogModel },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: '',
            pledges: {},
            karadModal: null,
            unit: {},
            permissions: {},
            isMember: '',
            member: null,
            member_list: [],
            name: '',
            mobile: '',
            suggested_amount: '',
            notes: '',
            collected_amount: '',
            receipt_no: '',
            isEdit: false,
            editable_id: null,
            availableReceiptNumbers: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: {},
            currentPage: 1,
            duplicateMsg: '',
            duplicateDetails: null,
            district_name: '',
            zone_name: '',
            visitMode: false,
            visitingSaving: {},
            officeModal: null,
            officePledge: null,
            officeAmount: '',
            officeTxn: '',
            officeSlip: null,
            officeSlipName: '',
            officeSaving: false,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isStateAdmin() {
            return parseInt(this.currentUser && this.currentUser.user_level) === 1;
        },
    },
    mounted() {
        this.karadModal = new bootstrap.Modal(document.getElementById('karadModal'));
        this.officeModal = new bootstrap.Modal(document.getElementById('officeModal'));
        this.getPledges();
    },
    methods: {
        checkMobileDuplicate() {
            const mobile = String(this.mobile || '').trim();
            if (mobile.length < 10) { this.duplicateMsg = ''; this.duplicateDetails = null; return; }
            UserService.authPostRequest('check-fund-pledge-mobile', {
                mobile,
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
                editable_id: this.editable_id || null,
            }).then((response) => {
                const data = response.data && response.data.data;
                if (data && data.wrong_unit) {
                    this.duplicateDetails = data;
                    this.duplicateMsg = `ഈ നമ്പർ മറ്റൊരു യൂണിറ്റിലെ മെമ്പറിന്റേതാണ്: ${data.name} (${data.unit_name}, ${data.zone_name}, ${data.district_name})`;
                } else if (data && data.duplicate) {
                    this.duplicateDetails = data;
                    this.duplicateMsg = 'ഈ നമ്പർ ഇതിനകം ചേർത്തിട്ടുണ്ട്.';
                } else {
                    this.duplicateMsg = '';
                    this.duplicateDetails = null;
                }
            }).catch(() => { this.duplicateMsg = ''; this.duplicateDetails = null; });
        },
        getPledges(page = 1) {
            this.loading_list = true;
            UserService.authPostRequest(`get-fund-pledges?page=${page}`, {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                list_type: 'karad',
            }).then((response) => {
                this.loading_list = false;
                if (response.data.status === 'success') {
                    this.pledges = response.data.data.list;
                    this.unit = response.data.data.unit;
                    this.permissions = response.data.data.permissions;
                    this.district_name = this.unit.district_name || this.unit.district?.name || '';
                    this.zone_name = this.unit.zone_name || this.unit.zone?.name || '';
                    this.$root.updateParent('കരട് ലിസ്റ്റ് - ' + (this.unit.name_mal || ''));
                }
            }, () => { this.loading_list = false; });
        },
        getTextList(search) {
            if (!search) return;
            UserService.authPostRequest('get-typehead-values', {
                q: search,
                type: 0,
                filter: 'inside',
                unit_id: parseInt(this.$route.params.id),
                user_level: 4,
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.member_list = response.data.data.list;
                }
            });
        },
        loadAvailableReceiptNumbers(currentNo = null) {
            const data = {
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
            };
            if (currentNo) data.current_receipt_no = currentNo;
            UserService.authPostRequest('receipt-book/available-receipt-numbers', data).then((response) => {
                if (response.data.status === 'success') {
                    this.availableReceiptNumbers = response.data.data.numbers || [];
                }
            });
        },
        openAddModal() {
            this.resetForm();
            this.isEdit = false;
            this.loadAvailableReceiptNumbers();
            this.karadModal.show();
        },
        editPledge(pledge) {
            this.resetForm();
            this.isEdit = true;
            this.editable_id = pledge.id;
            this.name = pledge.name;
            this.mobile = pledge.mobile;
            this.suggested_amount = pledge.suggested_amount;
            this.notes = pledge.notes || '';
            this.isMember = pledge.member_id ? 'Y' : 'N';
            this.collected_amount = pledge.collected_amount || '';
            this.receipt_no = pledge.receipt_no || '';
            this.loadAvailableReceiptNumbers(pledge.receipt_no);
            this.karadModal.show();
        },
        resetForm() {
            this.isMember = '';
            this.member = null;
            this.member_list = [];
            this.name = '';
            this.mobile = '';
            this.suggested_amount = '';
            this.notes = '';
            this.collected_amount = '';
            this.receipt_no = '';
            this.editable_id = null;
            this.message = '';
            this.duplicateMsg = '';
            this.duplicateDetails = null;
        },
        savePledge() {
            if (this.isMember === 'Y' && !this.member) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (this.isMember === 'N' && !this.name) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി പേര് ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (this.duplicateDetails && this.duplicateDetails.wrong_unit) {
                this.alert_type = 'Warning';
                this.alert_message = 'ഈ നമ്പർ മറ്റൊരു യൂണിറ്റിലെ മെമ്പറിന്റേതാണ്. ഈ വ്യക്തിയെ ഈ യൂണിറ്റിൽ ചേർക്കാൻ കഴിയില്ല.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (this.duplicateDetails && this.duplicateDetails.duplicate) {
                this.alert_type = 'Warning';
                this.alert_message = 'ഈ വ്യക്തിയെ ഇതിനകം ചേർത്തിട്ടുണ്ട്. വീണ്ടും സേവ് ചെയ്യേണ്ടതില്ല.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (!this.suggested_amount) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി തുക ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.loading = true;
            const data = {
                unit_id: parseInt(this.$route.params.id),
                fund_type: parseInt(this.$route.params.type),
                list_type: 'karad',
                editable_id: this.editable_id,
                suggested_amount: this.suggested_amount,
                notes: this.notes,
                name: this.name,
                mobile: this.mobile,
                member_id: (this.isMember === 'Y' && this.member) ? this.member.id : null,
            };
            UserService.authPostRequest('store-fund-pledge', data).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    this.karadModal.hide();
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.message = response.data.message;
                }
            }, () => { this.loading = false; });
        },
        promotePledge() {
            if (!this.collected_amount || !this.receipt_no) {
                this.alert_type = 'Warning';
                this.alert_message = 'Amount and Receipt Number required.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.loading = true;
            UserService.authPostRequest('promote-fund-pledge', {
                pledge_id: this.editable_id,
                amount: this.collected_amount,
                receipt_no: this.receipt_no,
            }).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    this.karadModal.hide();
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.message = response.data.message;
                }
            }, () => { this.loading = false; });
        },
        openOfficePayment(pledge) {
            this.officePledge = pledge;
            this.officeAmount = pledge.collected_amount || pledge.suggested_amount || '';
            this.officeTxn = '';
            this.officeSlip = null;
            this.officeSlipName = '';
            this.officeModal.show();
        },
        onOfficeSlipChange(e) {
            const file = e.target.files && e.target.files[0];
            this.officeSlip = file || null;
            this.officeSlipName = file ? file.name : '';
        },
        submitOfficePayment() {
            if (!this.officeAmount || parseFloat(this.officeAmount) <= 0) {
                this.alert_type = 'Warning';
                this.alert_message = 'തുക നൽകുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (!this.officeSlip && !(this.officeTxn && this.officeTxn.trim())) {
                this.alert_type = 'Warning';
                this.alert_message = 'പേയ്മെന്റ് സ്ലിപ്പ് അപ്‌ലോഡ് ചെയ്യുക അല്ലെങ്കിൽ ട്രാൻസാക്ഷൻ ഐഡി നൽകുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.officeSaving = true;
            const fd = new FormData();
            fd.append('pledge_id', this.officePledge.id);
            fd.append('amount', this.officeAmount);
            if (this.officeTxn) fd.append('transaction_id', this.officeTxn);
            if (this.officeSlip) fd.append('slip', this.officeSlip);
            UserService.authPostRequest('move-draft-to-main-office', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(
                (response) => {
                    this.officeSaving = false;
                    this.alert_type = response.data.status === 'success' ? 'Success' : 'Warning';
                    this.alert_message = response.data.message;
                    if (response.data.status === 'success') this.officeModal.hide();
                    this.$refs.alert_model.openModel();
                    if (response.data.status === 'success') this.getPledges();
                },
                (error) => {
                    this.officeSaving = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        openWhatsApp(pledge) {
            const url = this.whatsappLink(pledge);
            setTimeout(() => { window.open(url, '_blank'); }, 300);
        },
        whatsappLink(pledge) {
            const unitName = this.unit.name_mal || this.unit.name || '';
            const donationParams = [];
            if (this.unit.district_id) donationParams.push('district_id=' + this.unit.district_id);
            if (this.unit.zone_id) donationParams.push('zone_id=' + this.unit.zone_id);
            if (this.unit.id) donationParams.push('unit_id=' + this.unit.id);
            const donationUrl = 'https://guideportal.wisdomislam.org/donation/unit_youth_dawa_fund'
                + (donationParams.length ? '?' + donationParams.join('&') : '');
            const msg = `*Wisdom Youth Da'wa Fund* 🌟\n\nഅസ്സലാമു അലൈക്കും ${pledge.name},\n\nതാഴെ നൽകിയ ലിങ്ക് വഴി നിങ്ങളുടെ സംഭാവന ഓൺലൈനായി നൽകാവുന്നതാണ്:\n\n🔗 ${donationUrl}\n\nഫോം ഫിൽ ചെയ്യുമ്പോൾ താഴെയുള്ള വിവരങ്ങൾ നേരത്തെ സെലക്ട് ചെയ്തിട്ടുണ്ടാവും:\n🏛️ District: ${this.district_name}\n📍 Zone: ${this.zone_name}\n🏠 Unit: ${unitName}\n\nജസാക്കല്ലാഹ് ഖൈർ 🤲`;
            const mobile = String(pledge.mobile).replace(/\D/g, '');
            const number = mobile.startsWith('91') ? mobile : '91' + mobile;
            return `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
        },
        toggleVisitMode() {
            this.visitMode = !this.visitMode;
        },
        markVisited(pledge, checked) {
            this.visitingSaving = { ...this.visitingSaving, [pledge.id]: true };
            UserService.authPostRequest('mark-pledge-visited', {
                id: pledge.id,
                visited: checked ? 1 : 0,
            }).then((response) => {
                this.visitingSaving = { ...this.visitingSaving, [pledge.id]: false };
                if (response.data.status === 'success') {
                    pledge.visited = checked;
                }
            }).catch(() => { this.visitingSaving = { ...this.visitingSaving, [pledge.id]: false }; });
        },
        confirmDelete(pledge) {
            this.dialog_action_params = { id: pledge.id };
            this.dialog_message = 'ഈ എൻട്രി ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deletePledge';
            this.$refs.dialog_model.openModel();
        },
        deletePledge(data) {
            UserService.authPostRequest('delete-fund-pledge', data).then((response) => {
                if (response.data.status === 'success') {
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.alert_type = 'Warning';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                }
            });
        },
    },
};
</script>

<style scoped>
.error-feedback { color: red; }
.listview { margin-bottom: 0; }

/* ── Office payment modal ───────────────────────────────────────── */
.office-note {
    background: #fff8ef;
    border: 1px solid #fde0a8;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 11.5px;
    line-height: 1.5;
    color: #92400e;
    margin-bottom: 14px;
}
.office-panel {
    border: 1.5px dashed #fbbf24;
    background: #fffbf3;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 16px;
}
.office-panel-title {
    font-weight: 700;
    font-size: 13px;
    color: #b45309;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    min-height: 92px;
    padding: 14px;
    border: 2px dashed #cbd5e1;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    text-align: center;
    transition: all .2s ease;
}
.upload-box:hover { border-color: #f59e0b; background: #fffaf0; }
.upload-box.filled { border-color: #16a34a; border-style: solid; background: #f0fdf4; }
.upload-icon { font-size: 30px; color: #94a3b8; }
.upload-box.filled .upload-icon { color: #16a34a; }
.upload-text { font-size: 13px; font-weight: 600; color: #475569; line-height: 1.4; }
.upload-text small { display: block; font-weight: 400; font-size: 11px; color: #94a3b8; margin-top: 2px; }
.upload-text.filled-text { color: #15803d; word-break: break-all; }
.upload-text.filled-text small { color: #4ade80; }
.office-or { text-align: center; margin: 12px 0; position: relative; }
.office-or::before { content: ""; position: absolute; top: 50%; left: 0; right: 0; height: 1px; background: #fde0a8; }
.office-or span { position: relative; background: #fffbf3; padding: 0 12px; font-size: 11px; color: #b45309; text-transform: uppercase; letter-spacing: 0.05em; }
.office-panel .input-wrapper .label em { font-style: normal; color: #94a3b8; font-weight: 400; }
</style>
